import { observer } from "mobx-react";
import CreateRmaFuqStore from "../stores/create-rma-fuq-store";
import { Textarea } from "../../../components/inputs/textarea/textarea";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../components/fonts/font-props";
import useTranslation from "../../../translation/hooks/translation-hook";
import MediaUploadCRmaFuqAnswer from "./media-upload-crma-fuq-answer";

interface IFreeTextCRmaFuqAnswerProps {
    question: CreateRmaFuqStore;
    isRequired: boolean;
}

const FreeTextCRmaFuqAnswer: React.FC<IFreeTextCRmaFuqAnswerProps> = observer(({question, isRequired}) => {

    const answerStore = question.answers[0];
    const { getTranslation } = useTranslation();

    return (
    <>
        <Textarea
            required={isRequired}
            value={answerStore.answer}
            onChange={answerStore.setAnswer}
        />
        { !!question.isImageRequested &&
            <>
                <FontBody2 color={FONT_COLOR.PRIMARY3_50}>{getTranslation(question.imageInstruction)}</FontBody2>
                <MediaUploadCRmaFuqAnswer />
            </>
        }
    </>
    );
});

export default FreeTextCRmaFuqAnswer;